import { useMemo } from 'react';
import { useRoutes } from 'react-router-dom';
import { AuthRoutes } from '../packages/auth/routes/authRoutes';
import { getDashboardRoutes } from '../packages/dashboard/routes/dashboardRoutes';
import { maintenanceRoutes } from '../packages/maintenance/routes/maintenanceRoutes';

export default function Router() {
  // Built during render, not at module load, so the route tree matches the
  // signed-in user. The previous version also did `systemRoutes = AuthRoutes`
  // followed by `systemRoutes.push(...)`, which mutated the imported AuthRoutes
  // array in place and appended the dashboard routes again on every re-import.
  const routes = useMemo(
    () => [...AuthRoutes, ...getDashboardRoutes(), ...maintenanceRoutes],
    []
  );
  return useRoutes(routes);
}
